import {
    Grid as Grids,
    Paper,
    TableContainer,
    Typography as Type,
  } from "@mui/material";
  import React, { useEffect, useState } from "react";
  import { useLocation } from "react-router-dom";
import LeftSideNav from "../../../Components/LeftSideNav";
import TopNavBar from "../../../Components/TopNavbar";
import BreadcrumbsComponent from "../../../Components/BreadCrumbs";
import Fonts from "../../../Config/Fonts";
import Colors from "../../../theme/Colors";
  
  const ManufacturesDetails = () => {
    const location = useLocation();
    const { manufacturesData } = location?.state || {};
  
    const [breadcrumbs, setBreadcrumbs] = useState([]);
  
    useEffect(() => {
      if (manufacturesData) {
        setBreadcrumbs([
          { key: "1", href: "/", text: "Home" },
          { key: "2", href: "/userList", text: "Users" },
          { key: "3", href: `/`, text: `View ${manufacturesData?.user_first_name}` },
        ]);
      }
    }, [manufacturesData]);
  
    return (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "20% 85%",
          height: "100vh",
          width: "100vw",
          overflowX: "hidden",
          overflowY: "hidden",
        }}
      >
        <LeftSideNav />
  
        <div
          style={{
            display: "grid",
            gridTemplateRows: "15% 80%",
            backgroundColor: "#F0F5FF",
          }}
        >
          <div style={{ backgroundColor: "white", height: "7vh", width: "100%" }}>
            <TopNavBar />
  
            <div
              style={{
                marginLeft: "30px",
                justifyContent: "flex-start",
                display: "flex",
              }}
            >
              <h2>Manufacturer</h2>
            </div>
  
            <BreadcrumbsComponent breadcrumbs={breadcrumbs} />
          </div>
  
          <TableContainer
            component={Paper}
            style={{
              width: "75vw",
              border: "1px solid #ccc",
              borderRadius: "15px",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
              marginTop: "40px",
              paddingLeft: "20px",
              paddingRight: "20px",
              marginLeft: "30px",
            }}
          >
            <h1 style={mainHeadingStyle}>View {manufacturesData?.user_first_name} Details</h1>
  
            <hr />
            <Grids container spacing={2} style={{ marginTop: "10px" }}>
              <Grids item xs={12} sm={4}>
                <Type variant="subtitle1" style={labelInfoStyle}>
                  User ID
                </Type>
  
                <Type style={inputTextStyle}>{manufacturesData.user_id}</Type>
              </Grids>
              <Grids item xs={12} sm={4}>
                <Type variant="subtitle1" style={labelInfoStyle}>
                  Name
                </Type>
  
                <Type style={inputTextStyle}>
                  {`${manufacturesData?.user_first_name} ${manufacturesData.user_last_name}`}
                </Type>
              </Grids>
              <Grids item xs={12} sm={4}>
                <Type variant="subtitle1" style={labelInfoStyle}>
                  Shop Name
                </Type>
  
                <Type style={inputTextStyle}>{manufacturesData?.shopName || "-"}</Type>
              </Grids>
  
              <Grids item xs={12} sm={4}>
                <Type variant="subtitle1" style={labelInfoStyle}>
                  City
                </Type>
  
                <Type style={inputTextStyle}>{manufacturesData?.city || "-"}</Type>
              </Grids>
  
              <Grids item xs={12} sm={4}>
                <Type variant="subtitle1" style={labelInfoStyle}>
                  State
                </Type>
  
                <Type style={inputTextStyle}>{manufacturesData?.state || "-"}</Type>
              </Grids>
  
              <Grids item xs={12} sm={4}>
                <Type variant="subtitle1" style={labelInfoStyle}>
                  Mobile No
                </Type>
  
                <Type style={inputTextStyle}>{manufacturesData?.user_mobile_number}</Type>
              </Grids>
  
              <Grids item xs={12} sm={4}>
                <Type variant="subtitle1" style={labelInfoStyle}>
                  Alternate No
                </Type>
  
                <Type style={inputTextStyle}>{manufacturesData?.alternateMobileNo || "-"}</Type>
              </Grids>
  
              <Grids item xs={12} sm={4}>
                <Type variant="subtitle1" style={labelInfoStyle}>
                  Email
                </Type>
  
                <Type style={inputTextStyle}>{manufacturesData?.user_email}</Type>
              </Grids>
            </Grids>
  
            <div style={{ marginTop: "80px" }}>
              <h1 style={mainHeadingStyle}>
                View {manufacturesData?.user_first_name} Additional Info
              </h1>
              <hr />
  
              <Grids container spacing={2} style={{ marginTop: "10px" }}>
                <Grids item xs={12} sm={4}>
                  <Type variant="subtitle1" style={labelInfoStyle}>
                    GST No.
                  </Type>
  
                  <Type style={inputTextStyle}>-</Type>
                </Grids>
  
                <Grids item xs={12} sm={4}>
                  <Type variant="subtitle1" style={labelInfoStyle}>
                    Pin code
                  </Type>
  
                  <Type style={inputTextStyle}>-</Type>
                </Grids>
  
                <Grids item xs={12} sm={4}>
                  <Type variant="subtitle1" style={labelInfoStyle}>
                    Register Date
                  </Type>
  
                  <Type style={inputTextStyle}>-</Type>
                </Grids>
  
                <Grids item xs={12} sm={4}>
                  <Type variant="subtitle1" style={labelInfoStyle}>
                    Status
                  </Type>
  
                  <Type style={inputTextStyle}>-</Type>
                </Grids>
  
                <Grids item xs={12} sm={4}>
                  <Type variant="subtitle1" style={labelInfoStyle}>
                    PAN Card
                  </Type>
  
                  <Type style={inputTextStyle}>-</Type>
                </Grids>
  
                <Grids item xs={12} sm={4}>
                  <Type variant="subtitle1" style={labelInfoStyle}>
                    Last Seen
                  </Type>
  
                  <Type style={inputTextStyle}>-</Type>
                </Grids>
  
                <Grids item xs={12} sm={4}>
                  <Type variant="subtitle1" style={labelInfoStyle}>
                    Last Order
                  </Type>
  
                  <Type style={inputTextStyle}>-</Type>
                </Grids>
              </Grids>
            </div>
          </TableContainer>
        </div>
      </div>
    );
  };
  
  const mainHeadingStyle = {
    fontSize: 16,
    fontWeight: "700",
    fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
    color: Colors.black,
    display: "flex",
    marginTop: "20px",
    marginBottom: "20px",
  };
  
  const labelInfoStyle = {
    fontSize: 16,
    fontWeight: "700",
    fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
    color: Colors.black,
    display: "flex",
  };
  
  const inputTextStyle = {
    fontSize: 16,
    fontWeight: "400",
    fontFamily: Fonts.NunitoSans, // Ensure this matches the loaded font
    color: Colors.darkGray,
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
  };
  
  export default ManufacturesDetails;
  